import { createAction, props } from '@ngrx/store';

export const setBuid = createAction('[BUID] Set', props<{ BUID: string }>());
export const setDBInitial = createAction('[DBInitial] Set', props<{ DBInitial: string }>());
export const setuserRoleId = createAction('[userRoleId] Set', props<{ userRoleId: string }>());
export const setuserRole = createAction('[userRole] Set', props<{ userRole: string }>());
export const setuserCategoryId = createAction('[userCategoryId] Set', props<{ userCategoryId: string }>());
export const setuserId = createAction('[userId] Set', props<{ userId: string }>());
export const setorganizationId = createAction('[organizationId] Set', props<{ organizationId: string }>());
export const setcompanyId = createAction('[companyId] Set', props<{ companyId: string }>());
export const setcountryId = createAction('[countryId] Set', props<{ countryId: string }>());
export const setStartDate = createAction('[StartDate] Set', props<{ startDate: string }>());
export const setEndDate = createAction('[EndDate] Set', props<{ endDate: string }>());
export const setLicId = createAction('[LicId] Set', props<{ licId: string }>());
export const setIsFileAttachment = createAction('[isFileAttachment] Set', props<{ isFileAttachment: boolean }>());
export const setIsPastDateAllowed = createAction('[isPastDateAllowed] Set', props<{ isPastDateAllowed: boolean }>());
export const setNoOfPastDatesAllowed = createAction('[noOfPastDatesAllowed] Set', props<{ noOfPastDatesAllowed: number }>());
export const setsessionId = createAction('[sessionId] Set', props<{ sessionId: string }>());
export const setlicenseDay = createAction('[licenseDay] Set', props<{ licenseDay: string }>());

export const clearBuid = createAction('[BUID] Clear');
export const clearDBInitial = createAction('[DBInitial] Clear');
export const clearuserRoleId = createAction('[userRoleId] Clear');
export const clearuserRole = createAction('[userRole] Clear');
export const clearuserCategoryId = createAction('[userCategoryId] Clear');
export const clearuserId = createAction('[userId] Clear');
export const clearorganizationId = createAction('[organizationId] Clear');
export const clearcompanyId = createAction('[companyId] Clear');
export const clearcountryId = createAction('[countryId] Clear');
export const clearStartDate = createAction('[StartDate] Clear');
export const clearEndDate = createAction('[EndDate] Clear');
export const clearLicId = createAction('[LicId] Clear');
export const clearIsFileAttachment = createAction('[isFileAttachment] Clear');
export const clearIsPastDateAllowed = createAction('[isPastDateAllowed] Clear');
export const clearNoOfPastDatesAllowed = createAction('[noOfPastDatesAllowed] Clear');
export const logoutClearState = createAction('[Auth] Logout Clear State');
